var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlankReceipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "207px",
    height: "216px",
    viewBox: "0 0 207 216",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.1688238,0 L52.7220382,0 C78.9414016,9.3944358e-15 100.196395,21.2549936 100.196395,47.474357 L100.196395,47.474357 L100.196395,47.474357 L0.694466853,47.474357 C0.694466853,21.2549936 21.9494605,1.19218463e-14 48.1688238,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-844.000000, -407.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(844.000000, 407.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.560402,216 C157.29606,216 216.117556,195.779878 205.810962,139.985484 C200.960726,113.728899 193.429306,125.406565 163.980267,94.3190656 C134.531229,63.2315657 152.494939,6 94.5897397,6 C51.9261818,6 18,54.4106548 18,113.352106 C18,172.293557 65.8247441,216 111.560402,216 Z",
    id: "Oval",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D0D0D0",
    x: 51,
    y: 155,
    width: 112,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(121.415080, 98.242577) rotate(31.000000) translate(-121.415080, -98.242577) translate(70.915080, 72.242577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-4",
    transform: "translate(0.000000, 3.797949)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E1E1E1",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5399322,12.8242407 C11.6398012,32.8905284 18.9213163,42.9236723 37.3844775,42.9236723 C55.8476387,42.9236723 71.1523223,42.3274405 83.2985283,41.134977 C95.3675384,39.7582246 101.402043,42.5380361 101.402043,49.4744116 C101.402043,56.4107871 66.9635294,56.8703749 -1.91349862,50.8531749 L1.67351062,24.2264972 L15.5399322,12.8242407 Z",
    fill: "#D0D0D0",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.4163824,0 L50.4744797,0 C52.5720288,-8.29402723e-16 54.2724283,1.70039949 54.2724283,3.79794856 L54.2724283,3.79794856 L54.2724283,3.79794856 L46.6184338,3.79794856 C46.6184338,1.70039949 48.3188333,3.85313513e-16 50.4163824,0 Z",
    id: "Rectangle-Copy",
    fill: "#C5C5C5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51,109.043051 C57.0357168,106.847945 60.9980335,108.117548 62.8869499,112.851859 C64.7758663,117.586171 67.4802164,119.055172 71,117.258861",
    id: "Path-6",
    stroke: "#FBF8DC",
    opacity: 0.423956735
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2209056,118.555899 C53.5820462,116.422582 57.762433,117.669528 59.7620659,122.296738 C61.7616989,126.923948 64.6158717,128.363434 68.3245843,126.615196",
    id: "Path-6-Copy",
    stroke: "#FBF8DC",
    opacity: 0.423956735,
    transform: "translate(57.772745, 122.440207) rotate(-13.000000) translate(-57.772745, -122.440207) "
  }), /*#__PURE__*/React.createElement("text", {
    id: "+",
    fontFamily: "Quicksand-Bold, Quicksand",
    fontSize: 20,
    fontWeight: "bold",
    fill: "#D0D0D0"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 164,
    y: 20
  }, "+")), /*#__PURE__*/React.createElement("text", {
    id: "+-copy",
    fontFamily: "Quicksand-Medium, Quicksand",
    fontSize: 20,
    fontWeight: 400,
    fill: "#D0D0D0"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 163
  }, "+")), /*#__PURE__*/React.createElement("text", {
    id: "+-copy-2",
    fontFamily: "Quicksand-Medium, Quicksand",
    fontSize: 16,
    fontWeight: 400,
    fill: "#D0D0D0"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 34.464,
    y: 215
  }, "+")))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankReceipe);
export default __webpack_public_path__ + "static/media/blank-receipe.c38562ad42e9adc62b24879e06169602.svg";
export { ForwardRef as ReactComponent };